import {EntriesApp} from "./EntriesApp";
import ReactDOM = require("react-dom");
import React = require("react");
import './Styles.css';
import 'shared/styles/bootstrap.scss';



rnJQuery(()=>{
    for(let form of SmartFormsEntriesVar.Forms)
    {
        (form as any).ElementOptions=JSON.parse((form as any).ElementOptions);
        (form as any).ServerOptions=JSON.parse((form as any).ServerOptions);

    }
    ReactDOM.render(<EntriesApp/>,document.getElementById('app'));
})
